export default "__VITE_ASSET__CGB5Z0X3__"